<flow-header [title]="isEdit ? 'client.editClient' : 'createClient.title' | translate">
  <div class="flex flex-1 items-center justify-end gap-4">
    <flow-button theme="secondary" variation="outline" (onClick)="onCancel()">
      {{ 'global.cancel' | translate }}
    </flow-button>

    <flow-button theme="primary" variation="fill" (onClick)="saveClient()" [disabled]="!form.valid">
      {{ (isEdit ? 'global.save' : 'global.add') | translate }}
    </flow-button>
  </div>
</flow-header>

<div class="flex flex-col gap-4 w-full mt-6">
  <div #itemsBook>
    <div
      *ngFor="let step of steps; let i = index"
      (click)="setActiveStep(i, $event)"
      [ngClass]="i | bookStep: activeStep : isEdit"
      class="stepper-book">
      <div class="header-stepper-book">
        <div class="header-title-stepper-book">{{'createClient.client' | translate}}</div>
      </div>
      <div class="header-stepper-book">
        <div class="header-subtitle-stepper-book">{{step | translate}}</div>
      </div>
    </div>
  </div>

  <ng-container [ngSwitch]="activeStep">
    <div class="grid grid-cols-3 xl:grid-cols-4 gap-4" *ngSwitchCase="0">
      <form class="flex flex-col col-span-1 gap-4" [formGroup]="form">
        <div class="client-general-information-wrapper">
          <div class="general-information">
            <app-icon
              fill="#BFD6E4"
              iconName="annotation-info"
              size="md"
              class="w-8 h-8 bg-chathams-blue-400 rounded-full flex justify-center items-center"
              stroke="#598FAE"></app-icon>
            <h3 class="m-0 ml-3 text-text-primary font-semibold">{{ 'createScreen.generalInfo' | translate }}</h3>
          </div>
        </div>

        <flow-form-select
          *ngIf="isAdmin"
          formControlName="customerId"
          label="client.form.customer"
          placeholder="createClient.placeholder.chooseCustomer"
          [options]="customers"
          [multiple]="false"
          [required]="true"></flow-form-select>

        <flow-form-input
          formControlName="name"
          label="client.form.clientName"
          placeholder="createClient.placeholder.clientName"
          [required]="true"></flow-form-input>

        <div *ngIf="!isEdit" class="client-checkbox-wrapper">
          <mat-checkbox color="primary" formControlName="shouldCreateFolder" class="client-checkbox"></mat-checkbox>
          <div class="client-text">
            {{ 'createClient.createMediaFolder' | translate }}
            <span class="client-text">{{ 'createClient.client' | translate }}</span>
          </div>
        </div>

        <flow-form-input
          formControlName="vatNumber"
          label="client.form.vat"
          placeholder="createClient.placeholder.vatNumber"></flow-form-input>

        <flow-form-select
          formControlName="advertisingType"
          label="client.form.typeOfAdvertising"
          placeholder="createClient.placeholder.typeOfAdvertising"
          [options]="adTypes"
          [multiple]="false"></flow-form-select>

        <flow-form-textarea formControlName="additionalInformation" label="client.form.additionalInformation"></flow-form-textarea>
      </form>

      <div class="col-span-1 general-information-text-wrapper">
        <div class="note-wrapper">
          <div class="note">
            {{ 'createClient.note' | translate }}
          </div>
          <div class="note-main-text">
            {{ 'createClient.generalInformationNoteText' | translate }}
          </div>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="1">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        <div class="col-span-1">
          <form class="flex flex-col gap-4" [formGroup]="form">
            <div class="general-information">
              <app-icon
                fill="#BFD6E4"
                iconName="invoice"
                size="md"
                class="w-8 h-8 bg-chathams-blue-400 rounded-full flex justify-center items-center"
                stroke="#598FAE"></app-icon>
              <h3 class="m-0 ml-3 text-text-primary font-semibold">{{ 'createClient.invoice' | translate }}</h3>
            </div>

            <flow-form-input
              formControlName="address"
              label="client.form.address"
              placeholder="createClient.placeholder.addAddress"></flow-form-input>

            <div class="grid grid-cols-2 gap-4">
              <flow-form-input
                formControlName="postalCode"
                label="client.form.postalCode"
                placeholder="createClient.placeholder.addPostalCode"></flow-form-input>

              <flow-form-input
                formControlName="city"
                label="client.form.city"
                placeholder="createClient.placeholder.city"></flow-form-input>
            </div>

            <flow-form-select-country
              formControlName="country"
              [placeholder]="'createClient.placeholder.country'"
              [label]="'client.form.country'"
              [required]="true"
              [options]="countries$ | async"></flow-form-select-country>

            <flow-form-input
              formControlName="emailAddress"
              label="client.form.emailAddress"
              placeholder="createClient.placeholder.addEmailAddress"
              [errorMessage]="'global.validations.invalidEmail'"
              [required]="true"></flow-form-input>

            <flow-form-input
              formControlName="contactPerson"
              label="client.form.contactPerson"
              placeholder="createClient.placeholder.addContactPerson"></flow-form-input>

            <div>
              <mat-label>{{'client.form.phoneNumber' | translate}}</mat-label>
              <mat-form-field class="w-full">
                <ngx-mat-intl-tel-input
                  [enablePlaceholder]="true"
                  inputPlaceholder="{{ 'createClient.placeholder.addPhoneNumber' | translate }}"
                  [enableSearch]="true"
                  [preferredCountries]="['se']"
                  focused="true"
                  formControlName="phoneNumber"></ngx-mat-intl-tel-input>
              </mat-form-field>
            </div>

            <div class="grid grid-cols-2 gap-4">
              <flow-form-input
                formControlName="department"
                label="client.form.department"
                placeholder="createClient.placeholder.addDepartment"></flow-form-input>

              <flow-form-input
                formControlName="costCenter"
                label="client.form.costCenter"
                placeholder="createClient.placeholder.addCostCenter"></flow-form-input>
            </div>

            <div class="grid grid-cols-2 gap-4">
              <flow-form-select-currency
                formControlName="currency"
                [options]="currencies"
                [label]="'client.form.currency'"
                [placeholder]="'createClient.placeholder.addCurrency'"
                [required]="true"
                panelClass="min-w-36">
                <div suffix class="px-3">
                  <app-icon size="md" iconName="{{CurrencyEnum[form.get('currency').value]}}"></app-icon>
                </div>
              </flow-form-select-currency>

              <flow-form-select
                formControlName="pricingModel"
                [label]="'global.pricingModel'"
                [options]="pricingModels"
                [multiple]="false"
                [required]="true"
                panelClass="min-w-56"></flow-form-select>
            </div>

            <flow-form-input
              formControlName="paymentTerms"
              [label]="'client.form.paymentTerms' | translate"
              [placeholder]="'createClient.placeholder.paymentTerms' | translate"
              [required]="true"></flow-form-input>
              
            <div>
              <mat-label class="framework-agreement-text">{{'client.form.frameworkAgreement' | translate}}*</mat-label>

              <mat-radio-group class="flex flex-row gap-4" formControlName="frameworkAgreementEnabled">
                <mat-radio-button class="col-span-1" color="primary" [value]="true">
                  {{'global.yes' | translate}}
                </mat-radio-button>

                <mat-radio-button [value]="false" class="col-span-1" color="primary">
                  {{'global.no' | translate}}
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </form>
        </div>

        <div class="col-span-1 general-information-text-wrapper">
          <div class="note-wrapper">
            <div class="note">
              {{ 'createClient.note' | translate }}
            </div>
            <div class="note-main-text">
              {{ 'createClient.invoiceNoteText' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
